import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Dynamic } from '../../shared/model/dynamicfiled.model';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';



@Component({
    selector: 'app-customfield-dynamic-modal',
    templateUrl: './customfield-dynamic-modal.component.html',
    styleUrls: ['../documents.component.scss'],
    standalone: false
})
export class CustomfieldDynamicModalComponent implements OnInit {

  title: string
  typesDynamics:Dynamic[]
  selectedTypesDynamic = 2
  statusField:number = 2
  statusModal = false
  showMessage: boolean = false
  arrayTypesField: Array <any>
  showMessageArray: boolean = false


  nameNewField: FormControl = new FormControl('', [
    Validators.required,
    Validators.maxLength(50)
  ])

  form: FormGroup
  emptyButton: string

  @Output() passEntry: EventEmitter<any> = new EventEmitter();

  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
  ) {

    this.form =  this.fb.group({
      name: [''],
      type: '',
      select: this.fb.array([])
    });

  }

  ngOnInit() {
    this.typesDynamics =[
      {
        name: "Texto",
        type: 2
      },
      {
        name: "Select",
        type: 5
      },
      {
        name: "Fecha",
        type: 3
      },
    ]

  }
  setType(type){
    this.form.get('type').setValue(type)
  }
  get allItems() {
    return this.form.get('select') as FormArray;
  }

  addCustomfield() {
    (this.form.get('select') as FormArray).push(new FormControl('', Validators.required))

  }
  aceppt(){
    const stringSelect = (this.form.get('select') as FormArray).value.length > 0 ? JSON.stringify(this.form.get('select').value) : undefined
    if(this.form.get('name').value !== ""){
      this.activeModal.close({
        "name": this.form.get('name').value,
        "type": Number(this.form.get('type').value),
        "values": stringSelect
      })
    }else{
      this.showMessage = true
      setTimeout(
        () => this.showMessage = false,
      5000)
    }
  }

  confirm(typeListSubject) {
    const data = { ok:true, all: typeListSubject}
    this.passEntry.emit(data);

  }

  removeNewCustomField(i){
    (this.form.get('select') as FormArray).removeAt(i)
  }


}
